module.exports = __webpack_public_path__ + "static/img/home_index4_icon2.b86bdac8.png";